import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Box,
  Typography,
  Button,
  Avatar,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Grid2,
} from "@mui/material";
import {
  Email,
  Edit,
  Folder,
  Delete,
  CheckCircle,
  Notifications,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  activationRemider,
  DeleteUserProfileInternal,
  changeUserStatus,
  getSingleInternalResource,
} from "../../redux/Thunk/internalResourceThunk/internalResourceThunk";
import dayjs from "dayjs";
import Btn from "../../Components/Ui_elements/Btn";
import { Grid } from "@mui/material";
import PopupModal from "../../Components/Ui_elements/PopupModal";
import EmailClient from "../Admin/A_System/Templates/EmailClient";
import { sendMessage, activateUserProfile } from "../../redux/Thunk/authThunk/login";
import APP_CONFIG_URL_ENV from "../../env-config";
import { getCenteredPopupSize } from "../../Helper/Constants";
import { parseIMobile } from "../../Helper/phone";
import AbsenceManager from "../../Components/AbsenceManager/AbsenceManager";

const Viewinternal = ({ isProfilePage = false, UId }) => {
  const dispatch = useDispatch();
  const params = useParams();
  const ID = params?.id ? params?.id : UId;
  const navigate = useNavigate();
  const [tabValue, setTabValue] = React.useState(0);
  const { internalResource, edit_internal_resource_data } = useSelector(
    state => state.root.InternalResource
  );

  const [openForDelete, setOpenForDelete] = useState(false);
  const [openEmail, setOpenEmail] = useState(false);
  const emailRef = useRef();

  const [openStatusConfirm, setOpenStatusConfirm] = useState(false);
  const [pendingStatus, setPendingStatus] = useState(null);
  const [localUserStatus, setLocalUserStatus] = useState(null);

  const [openActivateConfirm, setOpenActivateConfirm] = useState(false);


  const { width, height, left, top } = getCenteredPopupSize(0.6, 0.7);

  useEffect(() => {
    dispatch(getSingleInternalResource(ID));
  }, []);

  const profileImage = edit_internal_resource_data?.vProfilePic || "";
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleActivationRemider = resource => {
    dispatch(activationRemider(resource));
  };

  const handleProfileActivate = () => {
    setOpenActivateConfirm(true);
  };

  const confirmProfileActivate = () => {
    dispatch(activateUserProfile({ user_id: ID })).then(res => {
      dispatch(getSingleInternalResource(ID));
      setOpenActivateConfirm(false);
    });
  };



  const handleEmail = () => {
    const sendTo = internalResource?.vEmailAddress || "";
    window.location.href = `mailto:${sendTo}`;
    //setOpenEmail(true);
  };

  const mobileParsed = parseIMobile(internalResource?.iMobile);
  const mobileNumber = mobileParsed?.formattedMobileNumber || mobileParsed?.rawMobileNumber || "";

  const handleEdit = () => {
    navigate(`/manage/internal/${ID}`);
  };
  const handleFileManager = () => {
    window.open(
      `/filemanage/item?userId=${ID}`,
      "FileManagerPopup",
      `width=${width},height=${height},top=${top},left=${left},` +
      "menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes"
    );
  };
  const handleDeleteInternalResource = () => {
    setOpenForDelete(true);
  };
  const handleConfirmDelete = () => {
    const payload = {
      id: ID,
      profile: profileImage,
    };
    dispatch(DeleteUserProfileInternal(payload)).then(() => {
      setOpenForDelete(false);
      navigate("/resources/internal");
    });
  };

  const handleSetAsActive = () => {
    const currentStatus = localUserStatus !== null ? localUserStatus : internalResource?.eUserStatus;
    const newStatus = currentStatus === 3 ? 4 : 3; // Toggle between 3 (active) and 4 (inactive)

    setPendingStatus(newStatus);
    setOpenStatusConfirm(true);
  };

const confirmStatusChange = () => {
  const payload = {
    id: ID,
    eUserStatus: pendingStatus,
  };

  dispatch(changeUserStatus(payload)).then(res => {
      if (res?.type?.includes("fulfilled")) {
        // Check if the API call was successful (status 200)
        if (res?.payload?.status === 200) {
          setLocalUserStatus(pendingStatus);
          dispatch(getSingleInternalResource(ID));   // only for internal
          setOpenStatusConfirm(false);
        } else if (res?.payload?.status === 422) {
          // Backend validation failed - don't update local state
          setOpenStatusConfirm(false);
        }
      }
      setOpenStatusConfirm(false);
    });
  };
  const getUserStatusConfig = status => {
    switch (status) {
      case 3: // Active
        return {
          text: "Set As Deactivated",
          color: "success",
          variant: "contained",
          disabled: false,
        };
      case 4: // Inactive
      case 15: // Blacklisted
      default:
        return {
          text: "Set As Active",
          color: "primary",
          variant: "contained",
          disabled: false,
        };
    }
  };

  const handleSubmitMail = async () => {
    if (emailRef.current && emailRef.current.handleSubmit) {
      try {
        const response = await emailRef.current.handleSubmit();
        if (response !== null) {
          dispatch(sendMessage({ id: ID, data: response }));
          setOpenEmail(false); // Close modal on success
        }
      } catch (error) {
        console.error("Failed to send email:", error);
      }
    } else {
      console.error("Email ref or handleSubmit not available");
    }
  };

  useEffect(() => {
    if (internalResource?.eUserStatus !== undefined) {
      setLocalUserStatus(internalResource.eUserStatus);
    }
  }, [internalResource?.eUserStatus]);

  return (
    <Container sx={{ bgcolor: "#f4f0ff", p: 3, borderRadius: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button variant="contained" onClick={() => navigate(-1)} sx={{ ml: 1, borderRadius: 2 }}>
          Back
        </Button>
      </Box>

      <Box
        sx={{
          p: 2,
          borderRadius: 3,
          background: "#fff",
          overflow: "hidden",
        }}
      >
        {/* Grid container for profile and buttons */}
        <Grid container spacing={1} alignItems="center">
          {/* Profile section */}
          <Grid item xs={12} md={1.5}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Avatar
                src={
                  internalResource?.S3vProfilePic
                    ? internalResource?.S3vProfilePic
                    : internalResource?.vProfilePic
                    ? `${APP_CONFIG_URL_ENV.REACT_APP_FILEPATH}profilePic/${internalResource?.vProfilePic}`
                    : internalResource?.vProfilePic
                }
                sx={{
                  width: 90,
                  height: 90,
                  mr: 3,
                  border: "3px solid white",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                }}
              />
            </Box>
          </Grid>

          {/* Buttons section */}
          <Grid item xs={12} md={10.5}>
            <Box>
              <Typography variant="h6" fontWeight="bold">
                {internalResource?.vFirstName + " " + internalResource?.vLastName || "N/A"}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary" sx={{ mt: 0.5 }}>
                I work in the{" "}
                <Box component="span" fontWeight="600">
                  {internalResource?.vResourcePositionName || ""}
                </Box>{" "}
                department
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
                mt: 2,
                justifyContent: { xs: "flex-start", md: "flex-start" },
              }}
            >
              <Button
                variant="contained"
                color="primary"
                startIcon={<Email />}
                onClick={handleEmail}
                sx={{ borderRadius: 2 }}
              >
                Email
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleEdit}
                startIcon={<Edit />}
                sx={{ borderRadius: 2 }}
              >
                Edit
              </Button>
              <Button
                variant="contained"
                color="info"
                onClick={handleFileManager}
                startIcon={<Folder />}
                sx={{ borderRadius: 2 }}
              >
                File Manager
              </Button>
              {!isProfilePage && (
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleDeleteInternalResource}
                  startIcon={<Delete />}
                  sx={{ borderRadius: 2 }}
                >
                  Delete
                </Button>
              )}
              {!isProfilePage && (
                <Button
                  variant={getUserStatusConfig(localUserStatus).variant}
                  color={getUserStatusConfig(localUserStatus).color}
                  startIcon={<CheckCircle />}
                  sx={{
                    borderRadius: 2,
                    textTransform: "none",
                  }}
                  onClick={() => {
                    if (!getUserStatusConfig(localUserStatus).disabled) {
                      handleSetAsActive();
                    }
                  }}
                >
                  {getUserStatusConfig(localUserStatus).text}
                </Button>
              )}
              {!isProfilePage && internalResource?.activation_status === 0 && (
                <>
                  <Button
                    variant="contained"
                    color="warning"
                    startIcon={<CheckCircle />}
                    onClick={handleProfileActivate}
                    sx={{ borderRadius: 2 }}
                  >
                    Profile Activate
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<Notifications />}
                    onClick={() => handleActivationRemider(internalResource)}
                    sx={{ borderRadius: 2 }}
                  >
                    Activation Reminder
                  </Button>
                </>
              )}

            </Box>
          </Grid>
        </Grid>
      </Box>

      <Tabs value={tabValue} onChange={handleTabChange} className="custom-tabs">
        <Tab label="Overview" sx={{ color: "purple", "&.Mui-selected": { color: "black" } }} />
        <Tab
          label="Basic Information"
          sx={{
            color: "purple",
            "&.Mui-selected": { color: "black" }, // Active tab color
          }}
        />
        <Tab
          label="Contact Information"
          sx={{
            color: "purple",
            "&.Mui-selected": { color: "black" },
          }}
        />
        <Tab
          label="Absent List"
          sx={{
            color: "purple",
            "&.Mui-selected": { color: "black" },
          }}
        />
      </Tabs>

      <Box sx={{ mt: 1, bgcolor: "#ffffff", p: 1, borderRadius: 1 }}>
        {tabValue === 0 && (
          <Grid container spacing={2} sx={{ mt: 2 }}>
            {/* Box 1 – Basic Info */}
            <Grid item xs={12} md={6}>
              <Box sx={{ p: 2, borderRadius: 2 }}>
                <Typography className="customCardHeader" pl={1}>
                  Basic Information
                </Typography>
                <TableContainer>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
                        <TableCell>{internalResource.vUserName || "N/A"}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>Position</TableCell>
                        <TableCell>{internalResource.vResourcePositionName || "N/A"}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>Gender</TableCell>
                        <TableCell>{internalResource.iGender === 1 ? "Male" : "Female"}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>Date of Birth</TableCell>
                        <TableCell>
                          {internalResource.dtBirthDate &&
                          internalResource.dtBirthDate !== "0000-00-00" &&
                          dayjs(internalResource.dtBirthDate).isValid() &&
                          !dayjs(internalResource.dtBirthDate).isAfter(dayjs())
                            ? `${dayjs(internalResource.dtBirthDate).format("DD.MM.YYYY")}`
                            : "N/A"}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>

            {/* Box 2 – Contact Info */}
            <Grid item xs={12} md={6}>
              <Box sx={{ p: 2, borderRadius: 2 }}>
                <Typography className="customCardHeader" pl={1}>
                  Contact Information
                </Typography>
                <TableContainer>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>Resource Number</TableCell>
                        <TableCell>00{internalResource?.iResourceNumber || "N/A"}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>Email</TableCell>
                        <TableCell>{internalResource?.vEmailAddress || "N/A"}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>Mobile</TableCell>
                        <TableCell>{mobileNumber || "N/A"}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>Slack/Teams</TableCell>
                        <TableCell>{internalResource?.vSkypeName || "N/A"}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>

            {/* Box 3 – Absent List */}
            <Grid item xs={12} md={12}>
              <Box sx={{ p: 2, borderRadius: 2 }}>
                <AbsenceManager
                  userId={Number(ID)}
                  userName={internalResource?.vUserName || internalResource?.vFirstName}
                  readOnly
                  showAddButton={false}
                />
              </Box>
            </Grid>
          </Grid>
        )}
        {tabValue === 1 && (
          <Box sx={{ mt: 2, p: 2 }}>
            <TableContainer>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
                    <TableCell>{internalResource.vUserName || "N/A"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Position</TableCell>
                    <TableCell>{internalResource.vResourcePositionName || "N/A"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Gender</TableCell>
                    <TableCell>{internalResource.iGender === 1 ? "Male" : "Female"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Date of Birth</TableCell>
                    <TableCell>
                      {internalResource.dtBirthDate &&
                      internalResource.dtBirthDate !== "0000-00-00" &&
                      dayjs(internalResource.dtBirthDate).isValid() &&
                      !dayjs(internalResource.dtBirthDate).isAfter(dayjs())
                        ? `${dayjs(internalResource.dtBirthDate).format("DD.MM.YYYY")}`
                        : "N/A"}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
        {tabValue === 2 && (
          <Box sx={{ mt: 2, p: 2 }}>
            <TableContainer>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Resource Number</TableCell>
                    <TableCell>00{internalResource?.iResourceNumber || "N/A"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Email Address</TableCell>
                    <TableCell>{internalResource?.vEmailAddress || "N/A"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Mobile Number</TableCell>
                    <TableCell>{mobileNumber || "N/A"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Slack/Teams</TableCell>
                    <TableCell>{internalResource?.vSkypeName || "N/A"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Creation Date</TableCell>
                    <TableCell>
                      {dayjs(internalResource?.dtCreatedDate).format("DD.MM.YYYY") || "N/A"}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Creator</TableCell>
                    <TableCell>{internalResource?.createdBy || "N/A"}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
        {tabValue === 3 && (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <AbsenceManager
                userId={Number(ID)}
                userName={internalResource?.vUserName || internalResource?.vFirstName}
              />
            </Grid>
          </Grid>
        )}
        {openForDelete && (
          <PopupModal
            maxWidth={"xs"}
            size={"sm"}
            width="650px"
            fullWidth={false}
            open={openForDelete}
            handleClose={() => setOpenForDelete(false)}
            actions={
              <Grid container columnGap={2} justifyContent={"end"}>
                <Btn onClick={() => handleConfirmDelete()}>Yes</Btn>
                <Btn onClick={() => setOpenForDelete(false)}>Cancel</Btn>
              </Grid>
            }
            title={
              <Typography variant="h6">Are you sure you want to delete this resource? </Typography>
            }
          >
            <Typography>
              Please note that all information in this resource profile will be deleted.
            </Typography>
          </PopupModal>
        )}
        {openEmail && (
          <PopupModal
            open={openEmail}
            maxWidth="lg"
            title="Mail"
            handleClose={() => setOpenEmail(false)}
            actions={
              <>
                <Btn onClick={handleSubmitMail}>Send Mail</Btn>
                <Btn variant="outlined" onClick={() => setOpenEmail(false)}>
                  Cancel
                </Btn>
              </>
            }
          >
            <Typography variant="body1">
              <EmailClient
                ref={emailRef}
                general={true}
                invoiceNumber={internalResource?.vUserName}
                email={internalResource?.vEmailAddress || ""}
                showFromProfile={true}
              />
            </Typography>
          </PopupModal>
        )}
        {openStatusConfirm && (
          <PopupModal
            maxWidth={"sm"}
            size={"sm"}
            width="650px"
            fullWidth={true}
            open={openStatusConfirm}
            handleClose={() => setOpenStatusConfirm(false)}
            actions={
              <Grid container columnGap={2} justifyContent={"end"}>
                <Btn onClick={confirmStatusChange}>Yes</Btn>
                <Btn onClick={() => setOpenStatusConfirm(false)}>Cancel</Btn>
              </Grid>
            }
            title={
              <Typography variant="h6">
                {pendingStatus === 3 ? "Activate User" : "Deactivate User"}
              </Typography>
            }
          >
            <Typography>
              Are you sure you want to {pendingStatus === 3 ? "activate" : "deactivate"} this user?
            </Typography>
          </PopupModal>
        )}

        {openActivateConfirm && (
          <PopupModal
            maxWidth={"sm"}
            size="sm"
            width="500px"
            fullWidth={true}
            open={openActivateConfirm}
            handleClose={() => setOpenActivateConfirm(false)}
            actions={
              <Grid container columnGap={2} justifyContent={"end"}>
                <Btn onClick={confirmProfileActivate}>Yes</Btn>
                <Btn variant="outlined" onClick={() => setOpenActivateConfirm(false)}>
                  Cancel
                </Btn>
              </Grid>
            }
            title={<Typography variant="h6">Activate Profile</Typography>}
          >
            <Typography variant="body1">Are you sure you want to activate this user profile?</Typography>
          </PopupModal>
        )}
      </Box>
      {/* <Typography variant="body2" align="left" sx={{ mt: 4, color: "gray" }}>
        &copy; 2015 Copyright.
      </Typography> */}
    </Container>
  );
};

export default Viewinternal;
